import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { useNavigate } from "react-router-dom/dist";

export default function Searchbar({ sx }) {
  const [value, setValue] = useState("");
  const navigate = useNavigate();
  const handleSearch = (e) => {
    // console.log("enter key was pressed", e.key === "Enter");
    if (e.key === "Enter") {
      const url = `/catagory/0?search=${value}`;
      navigate(url);
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <TextField
      sx={sx}
      color="primary"
      size="small"
      variant="outlined"
      placeholder="البحث"
      value={value}
      onChange={handleChange}
      onKeyDown={handleSearch}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton edge="end">
              <AiOutlineSearch />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
